import { render, staticRenderFns } from "./rich-text.vue?vue&type=template&id=1a2c6016&scoped=true&"
import script from "./rich-text.vue?vue&type=script&lang=js&"
export * from "./rich-text.vue?vue&type=script&lang=js&"
import style0 from "./rich-text.vue?vue&type=style&index=0&id=1a2c6016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2c6016",
  null
  
)

export default component.exports